module.exports = __webpack_public_path__ + "static/IMG_20200719_095646-46f703e0c60f64ce2037c41c924179b9.jpg";